<template>
    <b-modal :active.sync="isActive"
             has-modal-card full-screen >
        <div class="modal-card">
            <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
            <header class="modal-card-head">
                <p class="modal-card-title">
                </p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">


                <b-tabs v-model="activeTab">
                    <!--   Drugs tab     -->
                    <b-tab-item label="Drugs"  icon="pill">
                        <nav class="level is-mobile">
                            <div class="level-left">

                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-info is-light" icon-left="refresh" @click="refreshDrug">Refresh</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="plus" @click="addNewDrug">Add</b-button>
                                </div>
                            </div>
                        </nav>

                    <!-- ********************************************** -->

                        <b-table
                                :data="dataDrugs"
                                :bordered=false
                                :striped=false
                                narrowed
                                :hoverable=false
                                :focusable=false
                                mobile-cards>

                            <b-table-column   label="Drug Name"  v-slot="props"  >
                                 {{props.row.name}}
                            </b-table-column>
                            <b-table-column   label="Status"  v-slot="props"  >
                                <b-icon :type="props.row.enable ? 'is-success' : 'is-danger'"
                                        :icon="props.row.enable ? 'checkbox-marked-circle' : 'cancel'">
                                </b-icon>
                            </b-table-column>
                            <b-table-column   label="#"  v-slot="props"  >
                                <b-button type="is-warning"
                                          icon-right="pencil"
                                          @click="editDrug(props.row)"
                                />

                            </b-table-column>

                        </b-table>
                    </b-tab-item>



                    <!--   Bacterial tab     -->
                    <b-tab-item label="Bacterial"  icon="bacteria">
                        <nav class="level is-mobile">
                            <div class="level-left">

                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-info is-light" icon-left="refresh" @click="refreshBact">Refresh</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="plus" @click="addNewBact">Add</b-button>
                                </div>
                            </div>
                        </nav>

                    <!-- ********************************************** -->

                        <b-table
                                :data="dataBacts"
                                :bordered=false
                                :striped=false
                                narrowed
                                :hoverable=false
                                :focusable=false
                                mobile-cards>

                            <b-table-column   label="Baterial Name / Organism name"  v-slot="props"  >
                                {{props.row.name}}
                            </b-table-column>

                            <b-table-column   label="Status"  v-slot="props"  >
                                <b-icon :type="props.row.enable ? 'is-success' : 'is-danger'"
                                        :icon="props.row.enable ? 'checkbox-marked-circle' : 'cancel'">
                                </b-icon>
                            </b-table-column>
                            <b-table-column   label="#"  v-slot="props"  >
                                <b-button type="is-warning"
                                          icon-right="pencil"
                                          @click="editBact(props.row)"
                                />
                            </b-table-column>

                        </b-table>
                    </b-tab-item>




                    <!--   Template tab     -->
                    <b-tab-item label="Template"  icon="view-list">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-button type="is-success is-light" icon-left="cloud-upload" @click="updateTmplate">Save Order Sort</b-button>
                                </div>
                            </div>
                            <div class="level-right">

                                <div class="level-item">
                                    <b-button type="is-success" icon-left="plus" @click="addDrugToTemplate">Add Drug</b-button>
                                </div>
                            </div>
                        </nav>
                    <!-- ********************************************** -->

                        <b-table
                                :data="tmplate.drugs"
                                :bordered=false
                                :striped=false
                                narrowed
                                :hoverable=false
                                :focusable=false

                                draggable
                                @dragstart="dragstart"
                                @drop="drop"
                                @dragover="dragover"
                                @dragleave="dragleave"

                                mobile-cards>
                            <b-table-column   label="No."  v-slot="props"  >
                                {{props.index +1 }}
                            </b-table-column>


                            <b-table-column   label="Drug Name"  v-slot="props"  >
                                {{props.row.drug_name}}
                            </b-table-column>

<!--                            <b-table-column   label="sort id"  v-slot="props"  >-->
<!--                                {{props.row.sort_id}}-->
<!--                            </b-table-column>-->


<!--                            <b-table-column   label="iddrug_uuid"  v-slot="props"  >-->
<!--                                {{props.row.iddrug_uuid}}-->
<!--                            </b-table-column>-->


                            <b-table-column   label="#"  v-slot="props"  >
                                <b-button type="is-danger"
                                          icon-left="delete"
                                          @click="deleteDrugFromTemplate(props.row.iddrug_uuid)"
                                >
                                    Delete
                                </b-button>
                            </b-table-column>

                        </b-table>
                    </b-tab-item>


                    <!--   Methods Master   -->
                    <b-tab-item label="Methods"  icon="view-list">
                        <nav class="level is-mobile">
                            <div class="level-left">
                               <div class="level-item">
                                 <b-button type="is-success is-light" icon-left="cloud-upload" @click="updateSortMethod" >Save Order Sort</b-button>
                               </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-info is-light" icon-left="refresh" @click="refreshMethod">Refresh</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="plus" @click="addMethods" >Add</b-button>
                                </div>
                            </div>
                        </nav>

                        <!-- ********************************************** -->

                        <b-table
                                :data="dataMethods"
                                :bordered=false
                                :striped=false
                                narrowed
                                :hoverable=false
                                :focusable=false


                                draggable
                                @dragstart="dragstartMethods"
                                @drop="dropMethods"
                                @dragover="dragoverMethods"
                                @dragleave="dragleaveMethods"

                                mobile-cards>

                            <b-table-column   label="Methods name"  v-slot="props"  >
                                {{props.row.name}}
                            </b-table-column>

                            <b-table-column   label="Status"  v-slot="props"  >
                                <b-icon :type="props.row.enable ? 'is-success' : 'is-danger'"
                                        :icon="props.row.enable ? 'checkbox-marked-circle' : 'cancel'">
                                </b-icon>
                            </b-table-column>


<!--                            <b-table-column   label="Sort"  v-slot="props"  visible="false" >-->
<!--                                {{props.row.sort_id}}-->
<!--                            </b-table-column>-->

<!--                            <b-table-column   label="uuid"  v-slot="props"  visible="false">-->
<!--                                {{props.row.uuid}}-->
<!--                            </b-table-column>-->

                            <b-table-column   label="#"  v-slot="props"  >
                                <b-button type="is-warning"
                                          icon-right="pencil"
                                          @click="editMethods(props.row)"
                                />
                            </b-table-column>

                        </b-table>
                    </b-tab-item>

                </b-tabs>


            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>

            </footer>


        </div>

        <EditDrug
            v-if="isEditDrugshowing"
            :dataDrugToEdit = "dataDrugToEdit"
            :mode = "editDrugMode"
            @close="closeEditDrug"
            @closeWithDataChange = "closeEditDrugWithDataChange"
        />


        <EditBact
            v-if="isEditBactshowing"
            :dataBactToEdit = "dataBactToEdit"
            :mode = "editBactMode"
            @close="closeEditBact"
            @closeWithDataChange = "closeEditBactWithDataChange"
        />

        <SelectDrug
                v-if="isShowSelectDrug"
                :isShowing = isShowSelectDrug
                @closeSelectDrug = "closeSelectDrug"
                @closeSelectDrugWithData = "closeSelectDrugWithData"
        />



        <EditAddMethodsBactAndFunc
                v-if="isShowAddMethodsBactAndFunc"
                :mode = "modeAddMethodsBactAndFunc"
                :dataMethods = "dataMethodsProps"
                :isShowing = isShowAddMethodsBactAndFunc
                @closeAddMethodsBactAndFunc = "closeAddMethodsBactAndFunc"
                @closeAddMethodsBactAndFuncWithData = "closeAddMethodsBactAndFuncWithData"
        />
    </b-modal>
</template>

<script>
    import axios from "axios";    /* eslint-disable */
    import {  getBaseURLforBackEnd , getConfigAxios , genUUID }  from '@/utils.js'
    import EditDrug from "./EditDrug";
    import EditBact from "./EditBact";
    import SelectDrug from "../../LABNonAutomate/Bact/SelectDrug";
    import EditAddMethodsBactAndFunc from "./EditAddMethodsBactAndFunc";
    import {mapState} from "vuex";

    export default {
        name: "BactDataMst",
        components:{
            EditDrug,
            EditBact,
            SelectDrug,
            EditAddMethodsBactAndFunc
        },
        props:{
            isComponentModalActive : Boolean
        },
        computed: {
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
        },
        methods:{
            addMethods(){
                this.dataMethodsProps.id  = ""
                this.dataMethodsProps.name = ""
                this.dataMethodsProps.enable = true
                this.dataMethodsProps.data = []
                // set mode
                this.modeAddMethodsBactAndFunc = 'I'
                this.isShowAddMethodsBactAndFunc = true
            },
            closeAddMethodsBactAndFuncWithData(){
                this.isShowAddMethodsBactAndFunc = false
                this.refreshMethod()
            },
            closeAddMethodsBactAndFunc(){
                this.isShowAddMethodsBactAndFunc = false
            },
            editMethods(data){
                // dataMethodsProps = {"id":"","name":"","enable": "","uuid":"","data":[{"id":"","data":""}]}
                // data === {"id":2,"name":"ตรวจหาเชื้อแบคทีเรียด้วยกล้องจุลทรรศน์ Gram stain","enable":true}
                this.dataMethodsProps.id  = data.id
                this.dataMethodsProps.name = data.name
                this.dataMethodsProps.enable = data.enable
                // find data array dataMethods_result_mst
               const dataMember =  this.dataMethods_result_mst.find(dat=>{
                    return dat.id_methodlab === this.dataMethodsProps.id
                })
               this.dataMethodsProps.data =   dataMember ?  dataMember.data : []
                // set mode
                this.modeAddMethodsBactAndFunc = 'U'
                // set uuid
                this.dataMethodsProps.data.forEach(dat=>{
                    dat.uuid = genUUID(12)
                })
                this.isShowAddMethodsBactAndFunc = true

            },

            // *************************************************************************************
            dragstart (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragover(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleave(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            drop(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElements(this.tmplate.drugs , this.draggingRowIndex ,droppedOnRowIndex )
                this.tmplate.drugs[droppedOnRowIndex]['uuid'] = genUUID(6)
                this.tmplate.drugs[this.draggingRowIndex]['uuid'] = genUUID(6)
            },


            // *************************************************************************************
            dragstartMethods (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragoverMethods(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleaveMethods(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropMethods(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElements(this.dataMethods, this.draggingRowIndex ,droppedOnRowIndex )
                this.dataMethods[droppedOnRowIndex]['uuid'] = genUUID(6)
                this.dataMethods[this.draggingRowIndex]['uuid'] = genUUID(6)
            },




            swapArrayElements (arr, indexA, indexB) {
                // var temp = arr[indexA];
                // arr[indexA] = arr[indexB];
                // arr[indexB] = temp;
                var temp = arr[indexA];
                arr.splice(indexA,1)
                arr.splice(indexB,0,temp)
                this.reMakeIndexSort(arr)
            },
            reMakeIndexSort(arr){
                for(var i = 0;i<arr.length;i++){
                        arr[i]['sort_id'] = i
                }
            },


            updateSortMethod(){
                // console.log(JSON.stringify(this.dataMethods))
                const datTo = {
                     "dat" : this.dataMethods
                }


                // console.log(JSON.stringify(datTo))


                this.isFullScreenSearching = true
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/labbact_update_sort_methods`, datTo, getConfigAxios())
                  .then((res)=>{
                      this.$buefy.dialog.alert({
                          title: 'Message',
                          message: `${res.data.msg}`,
                          type: 'is-success',
                          hasIcon: true,
                          icon: 'check',
                          iconPack: 'fa',
                          ariaRole: 'alertdialog',
                          ariaModal: true
                      })
                      vm.isFullScreenSearching = false
                  })

                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        vm.isFullScreenSearching = false
                    })

            },



            updateTmplate(){
               this.reMakeIndexSort(this.tmplate.drugs)
               // console.log( JSON.stringify(this.tmplate.drugs) )
               var arr = []  // {"id_drug":"" , "sort_id": "" }
               for(var i =0 ;i<this.tmplate.drugs.length;i++){
                   arr.push({"id_drug":this.tmplate.drugs[i].iddrug , "sort_id": this.tmplate.drugs[i].sort_id })
               }

                const  datTo = {
                   "data" : arr
                }

                this.isFullScreenSearching = true
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/update_templatebact`, datTo, getConfigAxios())
                    .then((res)=>{
                        this.$buefy.dialog.alert({
                            title: 'Message',
                            message: `${res.data.msg}`,
                            type: 'is-success',
                            hasIcon: true,
                            icon: 'check',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        vm.isFullScreenSearching = false
                    })

                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        vm.isFullScreenSearching = false
                    })
            },

            closeSelectDrugWithData(payload){
                // console.log(payload)
                // genUUID
                //{ "iddrug": 1, "drug_name": "Cephalexin", "idresult": null, "result_name": null, "idmic_prefix": null, "mic_prefix": null, "mic_val": null, "remark": "", "sort_id": 0, "iddrug_uuid": "4258511039b8" }
                payload.forEach(dat=>{
                    this.tmplate.drugs.push({ "iddrug": dat.id,
                                        "drug_name": dat.name,
                                        "idresult": null,
                                        "result_name": null,
                                        "idmic_prefix": null,
                                        "mic_prefix": null,
                                        "mic_val": null,
                                        "remark": "",
                                        "sort_id": -1,
                                        "iddrug_uuid": genUUID(10) })
                })


                this.isShowSelectDrug = false
            },
            closeSelectDrug(){
                this.isShowSelectDrug = false
            },
            addDrugToTemplate(){
                this.isShowSelectDrug = true
            },
            deleteDrugFromTemplate(_iddrug_uuid){
                 // console.log(_iddrug_uuid)
                 // arr.splice(indexA,1)
                 const tmp = this.tmplate.drugs.find(dat=>{
                     return dat.iddrug_uuid === _iddrug_uuid
                 })

                if(tmp){
                    this.$buefy.toast.open({
                        duration: 1200,
                        message: `<b>${tmp.drug_name}</b> has been delete!`,
                        position: 'is-bottom',
                        type: 'is-danger'
                    })

                    const memberIndex =  this.tmplate.drugs.indexOf(tmp)
                    this.tmplate.drugs.splice(memberIndex,1)


                }
            },

            refreshMethod(){
                this.loadData({all: false, bacts: false, drugs: false, template: false,want_mic : false,want_result_mst: false,want_method_mst: true,want_method_result_mst : true})
            },
            refreshBact(){
                this.loadData({all: false, bacts: true, drugs: false, template: false,want_mic : false,want_result_mst: false,want_method_mst: false,want_method_result_mst : false})
            },
            refreshDrug(){
                this.loadData({all: false, bacts: false, drugs: true, template: false,want_mic : false,want_result_mst: false,want_method_mst: false,want_method_result_mst : false})
            },
            closeBtn(){
               this.$emit('closeBactDataMst')
            },
            closeEditBactWithDataChange(){
                this.loadData({all: false, bacts: true, drugs: false, template: false,want_mic : false,want_result_mst: false,want_method_mst: false,want_method_result_mst : false})
                this.isEditBactshowing = false
            },
            closeEditBact(){
                this.isEditBactshowing = false
            },
            closeEditDrugWithDataChange(){
               this.loadData({all: false, bacts: false, drugs: true, template: false,want_mic : false,want_result_mst: false,want_method_mst: false,want_method_result_mst : false})
               this.isEditDrugshowing = false
            },
            closeEditDrug(){
               this.isEditDrugshowing = false
            },
            editBact(dat){
                this.dataBactToEdit =  JSON.parse(JSON.stringify(dat))
                this.editBactMode = 'U'
                this.isEditBactshowing = true
            },
            editDrug(dat){
               this.dataDrugToEdit =  JSON.parse(JSON.stringify(dat))
               this.editDrugMode = 'U'
               this.isEditDrugshowing = true
            },
            addNewBact(){
                this.dataBactToEdit = {"id": -1 ,"name": "","enable": true}
                this.editBactMode = 'I'
                this.isEditBactshowing = true
            },
            addNewDrug(){
                this.dataDrugToEdit = {"id": -1 ,"name": "","enable": true}
                this.editDrugMode = 'I'
                this.isEditDrugshowing = true
            },
            loadData(options){
                //  if all === true   don't care other
                //  if all === false  up to other
                // options = {all: true, bacts: true, drugs: true, template: true,want_mic : true,want_result_mst: true,method_mst: true}
                var datTo = {}
                if ( options.all ){
                      datTo = {
                                    "admin": true,
                                    "want_bact": true,
                                    "want_drugs": true,
                                    "want_template": true,
                                    "want_mic": true,
                                    "want_result_mst" : true,
                                    "want_method_mst": true,
                                    "want_method_result_mst": true,
                                   }
                }else{
                      datTo = {
                                    "admin": true,
                                    "want_bact": options.bacts,
                                    "want_drugs": options.drugs,
                                    "want_template": options.template,
                                    "want_mic": options.want_mic,
                                    "want_result_mst" : options.want_result_mst,
                                    "want_method_mst": options.want_method_mst,
                                    "want_method_result_mst": options.want_method_mst,
                                  }
                }



                // console.log(JSON.stringify(datTo))
                this.isFullScreenSearching = true
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_bact`, datTo, getConfigAxios())
                    .then((res)=>{
                        if(options.all){
                            vm.dataBacts =  res.data.bact
                            vm.dataDrugs =  res.data.drug
                            vm.tmplate   =  res.data.tmplate

                            vm.dataMethods = res.data.method_mst
                            vm.dataMethods_result_mst = res.data.method_result_mst

                        }else{
                            if(options.bacts){vm.dataBacts =  res.data.bact}
                            if(options.drugs){vm.dataDrugs =  res.data.drug}
                            if(options.template){vm.tmplate =  res.data.tmplate}
                            if(options.want_method_mst){vm.dataMethods =  res.data.method_mst}
                            if(options.want_method_mst){vm.dataMethods_result_mst =  res.data.method_result_mst}
                        }

                        // console.log(res.data)

                        vm.isFullScreenSearching = false
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        vm.isFullScreenSearching = false
                    })



            }
        },
        data(){
            return {
                isFullScreenSearching : false,
                isActive : true,
                activeTab : 0,

                dataBacts : [],
                dataDrugs : [],
                tmplate : [],
                dataMethods: [],
                dataMethods_result_mst :[],



                isEditDrugshowing : false,
                editDrugMode: '',
                dataDrugToEdit : {} , // empty object prepare for edit


                isEditBactshowing : false,
                editBactMode: '',
                dataBactToEdit : {} , // empty object prepare for edit

                isShowSelectDrug : false,
                isShowAddMethodsBactAndFunc : false,
                dataMethodsProps :{},
                modeAddMethodsBactAndFunc : 'I' // default Insert Mode
            }
        },
        watch:{
            isComponentModalActive : {
                immediate: true,
                handler: function (val) {
                    if(val){
                         this.loadData({all: true, bacts: true, drugs: true, template: true,want_mic : true,want_result_mst: true,want_method_mst: true  ,want_method_result_mst: true})
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>